import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InvoiceState {
  id: number | null
  invoiceNumber: string
}

const initialState: InvoiceState = {
  id: null,
  invoiceNumber: '',
};

export const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    setInvoiceId: (state, action: PayloadAction<number>) => ({
      ...state,
      id: action.payload,
    }),
    setInvoiceNumber: (state, action: PayloadAction<string>) => ({
      ...state,
      invoiceNumber: action.payload,
    }),
  },
});

export const {
  setInvoiceId,
  setInvoiceNumber,
} = invoiceSlice.actions;

export default invoiceSlice.reducer;
